import { render, staticRenderFns } from "./orderStatusDialog.vue?vue&type=template&id=8a32d6bc&scoped=true&"
import script from "./orderStatusDialog.vue?vue&type=script&lang=js&"
export * from "./orderStatusDialog.vue?vue&type=script&lang=js&"
import style0 from "./orderStatusDialog.vue?vue&type=style&index=0&id=8a32d6bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a32d6bc",
  null
  
)

export default component.exports